import { Box, BoxProps, Text } from "@chakra-ui/react"
import Header from "../components/Header"
import Footer from "../components/Footer"
import { ReactNode } from "react"

interface DefaultLayoutProps extends BoxProps {
    children: ReactNode
}

const DefaultLayout = ({ children, ...rest }: DefaultLayoutProps) => {
    return (
        <Box {...rest}>
            <Header />
            <Box pt={'100px'} minH={'600px'}>
                { children }
            </Box>
            <Footer />
        </Box>
    )
}

export default DefaultLayout